import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

export const YourReportsIcon = (props) => {
  const { themeName,getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.85937 0H4.05938C3.17572 0 2.45938 0.716345 2.45938 1.6V8.00001L2.94064 8.00001L3.97608 5.63794C4.44223 4.57454 5.88758 4.52739 6.45631 5.47455L6.47923 5.51273L6.54741 5.65321L7.92944 9.10452L8.20621 8.69716C8.41888 8.33061 8.78499 8.08225 9.19904 8.017L9.24165 8.01029L9.38898 7.99995H11.017C11.7902 7.99995 12.417 8.62675 12.417 9.39995C12.417 10.1018 11.9012 10.6822 11.2271 10.7842L11.186 10.7904L11.0439 10.7999H10.2116L8.87994 12.882C8.34932 13.8327 6.999 13.8238 6.4587 12.9171L6.4364 12.8797L6.37004 12.7424L5.19991 9.82028L5.13775 9.96209C4.95759 10.3731 4.59506 10.6664 4.16982 10.7643C4.14147 10.7708 4.11275 10.7765 4.08383 10.7813L4.0393 10.7887L3.88493 10.8L2.45938 10.8V14.4C2.45938 15.2837 3.17572 16 4.05938 16H13.6594C14.543 16 15.2594 15.2837 15.2594 14.4V6.4H10.4594C9.57677 6.4 8.86108 5.68536 8.85938 4.80316L8.85937 0Z"
        // fill={props.active?"white":"#7B7B7B"}
        fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
      />
      <path
        d="M10.4594 5.2C10.2385 5.2 10.0594 5.02091 10.0594 4.8V0.4L14.8594 5.2H10.4594Z"
        // fill={props.active?"white":"#7B7B7B"}
        fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
      />
      <path
        d="M3.46344 8.80001L1.45938 8.8L1.37712 8.80554L1.36891 8.80678C1.08032 8.85043 0.859375 9.09952 0.859375 9.40001C0.859375 9.73138 1.128 10 1.45938 10L3.85554 10L3.94454 9.99346L3.95345 9.99199C3.96583 9.98994 3.9781 9.98751 3.99025 9.98471C4.17256 9.94272 4.32789 9.81695 4.40506 9.6409L5.23327 7.75155L7.10237 12.4192L7.14146 12.5L7.14592 12.5075C7.37929 12.8992 7.97051 12.896 8.19067 12.475L9.77359 9.99994H11.017L11.0992 9.99441L11.1074 9.99317C11.396 9.94952 11.617 9.70043 11.617 9.39995C11.617 9.06857 11.3484 8.79994 11.017 8.79994H9.41704L9.33208 8.80591L9.32356 8.80725C9.13885 8.83636 8.97637 8.9506 8.88724 9.11833L7.74589 10.7982L5.8153 5.97696L5.77504 5.89401L5.77046 5.88638C5.52777 5.48222 4.90773 5.50526 4.70877 5.95912L3.46344 8.80001Z"
        // fill={props.active?"white":"#7B7B7B"}
        fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
      />
    </svg>
  );
};
